import { NombreTarotista } from '../../../data/personality'
import { DataType } from '../../../interfaces/utils'

export const interpret = (data: DataType, user: string, personality: NombreTarotista, type: string) => {
    let consult = `IMPORTANTE: esta NO es una tirada de tarot. NO hay cartas. NO inventes cartas ni hagas una lectura tarotística.

Realizá un análisis de compatibilidad de pareja usando ÚNICAMENTE astrología (signos y modalidades astrológicas) y numerología (números de personalidad), y brindá un porcentaje de compatibilidad entre ellos.

Datos:
- ${data.consultante.name}: nacimiento ${data.consultante.date}, signo ${data.consultante.zodiac}, número de personalidad ${data.consultante.personality}
- ${data.consultado.name}: nacimiento ${data.consultado.date}, signo ${data.consultado.zodiac}, número de personalidad ${data.consultado.personality}

El análisis debe ser lo más detallado y extenso posible, con lenguaje sencillo. Incluí compatibilidad sexual. Sé realista: no suavices lo que no encaja y no des consejos para “arreglar” la pareja. No menciones lo que no podés hacer.`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: '',
        cards: [],
        type,
    }

    return info
}
